<template>
  <div class="pagesize">
    <h1>当前可视区域大小</h1>
    <p>宽度: {{ pageSize.viewportWidth }} px</p>
    <p>高度: {{ pageSize.viewportHeight }} px</p>

    <hr>

    <h1>文档实际大小</h1>
    <p>总宽度: {{ pageSize.documentWidth }} px</p>
    <p>总高度: {{ pageSize.documentHeight }} px</p>
    <div class="fullscreen-container">
      <button @click="handleToggleFullscreen" class="fs-btn">
        <span v-if="!isFullscreen">🖥️ 点击进入全屏</span>
        <span v-else>❌ 点击退出全屏</span>
      </button>
      <p>当前状态: {{ isFullscreen ? '全屏中' : '窗口模式' }}</p>
    </div>
  </div>
</template>

<script>
import pageSizeMixin from '../bll/pageSize';
export default {
  name: "getPageSize",
  mixins: [pageSizeMixin],
  data() {
    return {
      isFullscreen: false
    };
  },
  mounted() {
    // 此时 this.pageSize 已经有了数据
    console.log('页面加载完成，大小为:', this.pageSize);
    // 监听全屏状态改变事件（不同浏览器前缀不同）
    document.addEventListener('fullscreenchange', this.updateFullscreenState);
    document.addEventListener('webkitfullscreenchange', this.updateFullscreenState);
    document.addEventListener('mozfullscreenchange', this.updateFullscreenState);
    document.addEventListener('MSFullscreenChange', this.updateFullscreenState);
  },
  beforeDestroy() {
    // 组件销毁时移除监听，防止内存泄漏
    document.removeEventListener('fullscreenchange', this.updateFullscreenState);
    document.removeEventListener('webkitfullscreenchange', this.updateFullscreenState);
    document.removeEventListener('mozfullscreenchange', this.updateFullscreenState);
    document.removeEventListener('MSFullscreenChange', this.updateFullscreenState);
  },
  methods: {
    updateFullscreenState() {
      this.isFullscreen = !!(document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement);
    },
    handleToggleFullscreen() {
      const element = document.documentElement; // 让 html 标签全屏（即整个页面）

      if (!this.isFullscreen) {
        // 进入全屏
        const requestMethod = element.requestFullscreen ||
          element.webkitRequestFullscreen ||
          element.mozRequestFullScreen ||
          element.msRequestFullscreen;

        if (requestMethod) {
          requestMethod.call(element);
        }
      } else {
        // 退出全屏
        const exitMethod = document.exitFullscreen ||
          document.webkitExitFullscreen ||
          document.mozCancelFullScreen ||
          document.msExitFullscreen;

        if (exitMethod) {
          exitMethod.call(document);
        }
      }
    }
  }
}
</script>

<style scoped>
.pagesize{
  color: #fff;
}
.pagesize p{
  font-size: 4rem;
}

.fullscreen-container{
  position: fixed;
  right: 20px;
  top: 20px;
  text-align: right;
}
.fs-btn{
  font-size: 18px;
  padding: 3px 5px;
  cursor: pointer;
}

.fullscreen-container p{
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/views/getPageSize.vue